/** JoyBoxLabs daily contract. Pure UTC functions, no network or publishing job. */
export const DAY_MS = 86400000;
export const utcDate = (date = new Date()) => new Date(date).toISOString().slice(0, 10);
export const utcDay = (date = new Date()) => Math.floor(new Date(date).getTime() / DAY_MS);
export const untilReset = (now = Date.now()) => DAY_MS - (now % DAY_MS);
// Pin an open session, so finishing after midnight cannot claim tomorrow's result.
let openedAt = null;
export const pinDailySession = () => { openedAt ??= Date.now(); };
export const dailyDate = () => new Date(openedAt ?? Date.now());
export const editionDate = (number, epoch = '2025-01-01') => utcDate(new Date(Date.parse(epoch + 'T00:00:00Z') + (number - 1) * DAY_MS));
/** Stable permuted deck: each item appears once per cycle. No adjacent cycle repeats. */
export function deckIndex(day, length, salt = 0) {
  if (!Number.isInteger(length) || length < 1) throw new RangeError('A daily deck needs content');
  // Fixed coprime stride spans the complete deck without finite schedules.
  let stride = Math.max(1, Math.floor(length * .618));
  const gcd = (a, b) => b ? gcd(b, a % b) : a;
  while (gcd(stride, length) !== 1) stride++;
  return ((day * stride + salt) % length + length) % length;
}
